import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { listMatches, toggleMatchParticipation } from '../utils/matchesApi';

export default function Matches() {
  const [matches, setMatches] = useState([]);
  const [search, setSearch] = useState('');
  const { currentUser } = useAuth();

  async function fetchMatches() {
    try {
      const ms = await listMatches();
      setMatches(ms);
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    fetchMatches();
  }, []);

  async function joinMatch(m) {
    if (!currentUser) return alert('Connectez-vous pour rejoindre');
    try {
      const joined = (m.members || []).includes(currentUser.id);
      await toggleMatchParticipation(m.id, currentUser.id, joined);
      fetchMatches();
    } catch (err) { console.error(err); }
  }

  const filtered = matches.filter(m => m.title?.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <h2>Matches</h2>
      <input placeholder="Rechercher un match" value={search} onChange={e => setSearch(e.target.value)} />
      <button onClick={fetchMatches}>Rafraîchir</button>
      <ul>
        {filtered.map(m => (
          <li key={m.id}>
            <strong>{m.title}</strong> — {m.sport} — {m.date}
            <div>Participants: {(m.members || []).length}</div>
            <button onClick={() => joinMatch(m)}>{(m.members || []).includes(currentUser?.id) ? 'Quitter' : 'Rejoindre'}</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
